import { Personalize as UFPersonalize } from "@uniformdev/context-react"
import generateComponents from "utils/generateComponents"

import { useConsole } from "contexts/Console"

function Variation({ index, items, currentIndex }) {
  const console = useConsole()
  const components = items.map(item => (index == null ? item : { ...item, index, isCurrent: index === currentIndex }))

  console.verbose("HeroMediaOverlayRoller:P13N:Variation(%o)", { index, items: components })
  return generateComponents(components, { console })
}

export function reduceItemsForGenerateComponents(items) {
  const list = Array.isArray(items) ? items : [items].filter(Boolean)

  return list.reduce((components, entry, index) => {
    if (!entry || typeof entry !== "object") return components

    if (entry._content_type_uid) {
      components.push(entry)
      return components
    }

    const slotItems = Array.isArray(entry.item?.item) ? entry.item.item.filter(Boolean) : Array.isArray(entry.item) ? entry.item.filter(Boolean) : []
    if (slotItems.length) {
      components.push(...slotItems)
      return components
    }

    const variants = Array.isArray(entry.item_p13n?.variants) ? entry.item_p13n.variants : []
    if (variants.length) {
      const uid = entry.item_p13n?._metadata?.uid ?? entry._metadata?.uid ?? `hero-media-overlay-roller-p13n-${index}`
      components.push(<P13N key={uid} uid={uid} index={components.length} variants={variants} />)
    }

    return components
  }, [])
}

export default function P13N({ index, uid, variants = [], currentIndex }) {
  const console = useConsole()
  const variations = variants
    .reduce((acc, variation, variationIndex) => {
      const items = Array.isArray(variation?.item) ? variation.item.filter(Boolean) : []
      if (!items.length) return acc

      const pz = variation?.criteria?.name ?? null
      acc.push({
        items,
        ...(index == null ? {} : { index }),
        ...(currentIndex == null ? {} : { currentIndex }),
        ...(pz ? { pz } : {}),
        key: `${uid}-${variationIndex}`,
      })
      return acc
    }, [])
    .sort((a, b) => +!!b?.pz - +!!a?.pz)

  console.verbose("HeroMediaOverlayRoller:P13N(%o)", { uid, index, variations })

  return variations.length ? <UFPersonalize variations={variations} component={Variation} /> : null
}
